'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (value) {
  if (Array.isArray(value)) value = value.join(',');

  return value.match(/-webkit-|-moz-|-ms-/) !== null;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/inline-style-prefix-all/lib/utils/isPrefixedValue.js
// module id = 237
// module chunks = 0